$(function () {
  var slide = cloneSlide();
  $('#slider')
    .css({
      width: 70 * slide.length + 'vw',
      maxWidth: 980 * slide.length + 'px',
    })
    .slick({
      fade: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
      arrows: false,
      dots: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      touchMove: false,
    });

  $('.seven-slider').slick({
    autoplay: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    appendArrows: '.slider-arrows',
    prevArrow: '<button class="seven-arrow seven-prev"></button>',
    nextArrow: '<button class="seven-arrow seven-next"></button>',
  });
});

function cloneSlide() {
  var slide = {};
  $('.slide-group').each(function () {
    slide.length = $(this).find('.slide').length;
    $(this)
      .addClass('origin')
      .css({
        width: 70 * slide.length + 'vw',
        maxWidth: 980 * slide.length + 'px',
      });
    $(this).clone().removeClass('origin').addClass('clone').appendTo('#slider');
  });

  return slide;
}
